import { createReducer, on } from '@ngrx/store';
import * as ApplicationModulesActions from './application-modules.actions';
import { ApplicationModulesResponse } from './application-modules.models';

export interface ApplicationModulesState {
  modules: { [key: string]: ApplicationModulesResponse };
  loading: boolean;
  error: string | null;
  currentKey: string | null;
}

export const initialState: ApplicationModulesState = {
  modules: {},
  loading: undefined,
  error: null,
  currentKey: null,
};

export const applicationModulesReducer = createReducer(
  initialState,
  on(ApplicationModulesActions.loadApplicationModules, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ApplicationModulesActions.loadApplicationModulesSuccess, (state, { key, modules }) => ({
    ...state,
    loading: false,
    error: null,
    modules: { ...state.modules, [key]: modules },
    currentKey: key,
  })),
  on(ApplicationModulesActions.loadApplicationModulesFailure, (state, { error, key }) => ({
    ...state,
    loading: false,
    error,
    modules: { ...state.modules, [key]: [] },
  })),
  on(ApplicationModulesActions.resetApplicationModules, () => initialState),
);
